import React from 'react';
import classNames from 'classnames';
import { NamedLink } from '../../../components';
import { DIGO_CLIENT_USER_TYPE, DIGO_SERVICES, signupLinkProps } from '../digoServices';
import css from './SectionHowItWorksDigo.module.css';

const STEPS = [
  {
    n: '1',
    title: 'Décris ta tâche',
    desc: 'Explique ce dont tu as besoin. Ajoute des photos pour donner le contexte.',
  },
  {
    n: '2',
    title: 'Publies ou cherches',
    desc: 'Des travailleurs certifiés Digo près de toi répondront à ta demande.',
  },
  {
    n: '3',
    title: "Un poids de moins sur les épaules",
    desc: 'Service rendu. Tu paies en ligne et laisses un avis pour la communauté.',
  },
];

const midpoint = Math.ceil(DIGO_SERVICES.length / 2);
const SERVICES_COLUMN_A = DIGO_SERVICES.slice(0, midpoint);
const SERVICES_COLUMN_B = DIGO_SERVICES.slice(midpoint);

const ServiceCard = ({ service }) => (
  <div className={css.serviceCard}>
    <img src={service.photo} alt="" className={css.servicePhoto} loading="lazy" />
    <div className={css.serviceText}>
      <div className={css.serviceLabel}>{service.label}</div>
      <div className={css.serviceSub}>{service.sub}</div>
    </div>
  </div>
);

/**
 * Vertical infinite scroll of service examples (Airtasker-style).
 */
const ServiceMarqueeColumn = ({ services, direction = 'up' }) => {
  const loopedServices = [...services, ...services];

  return (
    <div className={css.marqueeColumn}>
      <div
        className={classNames(css.marqueeTrack, {
          [css.marqueeTrackDown]: direction === 'down',
        })}
      >
        {loopedServices.map((service, index) => (
          <ServiceCard key={`${service.id}-${index}`} service={service} />
        ))}
      </div>
    </div>
  );
};

const SectionHowItWorksDigo = () => (
  <section className={css.root}>
    <div className={css.container}>

      {/* Colonne gauche — étapes */}
      <div className={css.left}>
        <h2 className={css.title}>
          Comment ça<br />fonctionne
        </h2>
        <p className={css.subtitle}>
          Gagne du temps et coche ta liste de tâches.
        </p>

        <div className={css.steps}>
          {STEPS.map(s => (
            <div key={s.n} className={css.step}>
              <div className={css.stepNum}>{s.n}</div>
              <div>
                <div className={css.stepTitle}>{s.title}</div>
                <div className={css.stepDesc}>{s.desc}</div>
              </div>
            </div>
          ))}
        </div>

        <NamedLink {...signupLinkProps(DIGO_CLIENT_USER_TYPE)} className={css.cta}>
          Affiche ton annonce
        </NamedLink>
      </div>

      {/* Colonne droite — grille animée de services (informatif) */}
      <div className={css.right}>
        <div className={css.servicesPanel} aria-label="Exemples de services sur Digo">
          <div className={css.marqueeMobile}>
            <ServiceMarqueeColumn services={DIGO_SERVICES} direction="up" />
          </div>
          <div className={css.marqueeDesktop}>
            <ServiceMarqueeColumn services={SERVICES_COLUMN_A} direction="up" />
            <ServiceMarqueeColumn services={SERVICES_COLUMN_B} direction="down" />
          </div>
        </div>

        <NamedLink name="HowItWorksPage" className={css.viewAll}>
          Comment ça fonctionne →
        </NamedLink>
      </div>

    </div>
  </section>
);

export default SectionHowItWorksDigo;
